import React from 'react';

/** Step-level intro copy — shown as a tooltip on the StepPane header. */
export const STEP_KIND_HELP = {
    llm: (
        <>
            Runs an AI instruction from your Library against the input expression.
            The model&apos;s reply is stored on this step&apos;s output (e.g.
            {' '}<span className="font-mono">@step_2.output</span>) for later steps to use.
        </>
    ),
    rag: (
        <>
            Searches a Knowledge collection and returns matching passages on this step&apos;s
            output (e.g. <span className="font-mono">@step_1.output.chunks</span>). Downstream
            LLM steps often use RAG output as context for answering.
        </>
    ),
    api: (
        <>
            Calls a saved REST API from Library → APIs and puts the response on this step&apos;s
            output (e.g. <span className="font-mono">@get_order.output.data</span>). Map path,
            query, header, and body fields using OEL expressions from inputs and prior steps.
        </>
    ),
    memory: (
        <>
            Loads conversation history for this session into this step&apos;s output
            (e.g. <span className="font-mono">@step_1.output</span>). Downstream AI or
            logic steps can use it as context. OpCodes only <strong>read</strong> memory in
            V1 — they do not store new messages.
        </>
    ),
    choose: (
        <>
            Branches execution based on conditions. Cases are evaluated top-down — the first
            {' '}<span className="font-mono">when</span> expression that is true runs its linked
            definition or flow. Use the default when nothing matches.
        </>
    ),
    subflow: (
        <>
            Runs a named reusable <strong>flow</strong> defined on this opcode (left panel →
            Flows). Pass parameters via <span className="font-mono">with</span> — each maps a
            flow input name to an OEL expression.
        </>
    ),
    tool: (
        <>
            Invokes an external tool and returns its result on this step&apos;s output. Use
            {' '}<strong>mcp</strong> for MCP server tools, or <strong>opcode_as_tool</strong> to
            run another opcode from your Library as a callable tool.
        </>
    ),
    parallel: (
        <>
            Runs multiple branches at the same time. Each branch is a full step (LLM, API, etc.)
            with its own config and <strong>unique id</strong>. When all branches finish, reference
            any result in later steps as{' '}
            <span className="font-mono">@branch_id.output</span> (e.g.
            {' '}<span className="font-mono">@lookup_a.output.result</span>).
            {' '}<span className="font-mono">when</span>,{' '}
            <span className="font-mono">for</span>, and{' '}
            <span className="font-mono">repeat_until</span> apply to individual branches — not to
            the parallel step itself.
        </>
    ),
    call: (
        <>
            Invokes a reusable <strong>definition</strong> — a single step saved under
            Definitions on this opcode. Arguments map to OEL values passed into that step.
        </>
    ),
};

export function getStepKindHelp(kind) {
    return STEP_KIND_HELP[kind] || null;
}
